import lineItemsModel from './lineItemsModel';


const beginCheckoutModel = function googleAnalyticsProductCheckoutModel(order, totals) {
  const { items } = order;

  return {
    event: 'begin_checkout',
    ecommerce: {
      currency: 'USD',
      value: parseFloat(totals.cartTotal.replace('$', '')),
      items: lineItemsModel(items),
    },
  };
};

const addPaymentInfoModel = function googleAnalyticsAddPaymentInfoModel(order, totals) {
  const { items } = order;

  return {
    event: 'add_payment_info',
    ecommerce: {
      currency: 'USD',
      value: parseFloat(totals.cartTotal.replace('$', '')),
      items: lineItemsModel(items),
    },
  };
};

const addShippingInfoModel = function googleAnalyticsAddShippingInfoModel(order, totals) {
  const { items } = order;

  return {
    event: 'add_shipping_info',
    ecommerce: {
      currency: 'USD',
      value: parseFloat(totals.cartTotal.replace('$', '')),
      items: lineItemsModel(items),
    },
  };
};

export {
  beginCheckoutModel,
  addPaymentInfoModel,
  addShippingInfoModel,
};
